export default "__VITE_ASSET__vVCZspz5__"